import api from 'api'
import { CompumaticPunch } from 'api/admin/timeClock/listCompumaticPunches'

export type EditCompumaticPunchParams = {
  punchId: number
  punchType: string
  punchAt: string
}

export async function editCompumaticPunch({
  punchId,
  punchType,
  punchAt,
}: EditCompumaticPunchParams): Promise<CompumaticPunch> {
  const result = await api.patch<CompumaticPunch>(
    `/admin/time_clock/compumatic_punches/${punchId}`,
    {
      punchType,
      punchAt,
    }
  )
  return result.data
}
